<template>
    <div class="card"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'CCard' });
</script>
